<template>
    <div>
      <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
      </div> 
      <template v-else>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
        <table class="w-full text-left rtl:text-right text-gray-700">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input id="checkbox-all-search" type="checkbox"
                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Patient Names
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  IP/OP No.
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Ward
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Date
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Status
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b" v-for="(requisition, index) in filteredRequisitions" :key="index">
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4" />
                  <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                </div>
              </td>
              <td class="px-6 py-2">{{ requisition.patient.first_name + " " + requisition.patient.last_name }}</td>
              <td class="px-6 py-2">{{ requisition.patient.ipop }}</td>
              <td class="px-6 py-2">{{ requisition.department.name }}</td>
              <td class="px-6 py-2">{{ new Date(requisition.created_at).toLocaleDateString('en-CA') }}</td>
              <td class="px-6 py-2">
                <span class="p-2 rounded-lg dark:text-custom-blue">
                  {{ requisition.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-center gap-4 mt-4">
        <button @click="previousPage" :disabled="currentPage === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
            viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m15 19-7-7 7-7" />
          </svg>
          Previous
        </button>
  
        <div class="flex items-center gap-2">
          <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{
            'bg-custom-blue text-white': page === currentPage,
            'text-custom-blue': page !== currentPage
          }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button">
            <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
              {{ page }}
            </span>
          </button>
        </div>
  
        <button @click="nextPage" :disabled="currentPage === totalPages"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          Next
          <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
            viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m9 5 7 7-7 7" />
          </svg>
        </button>
      </div>
      </template>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    name: "RequisitionsMadeReportTab",
    components: {
    },
    created() {
      this.getRequisitions();
    },
    props: {
      searchQuery: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        currentPage: 1,
        totalPages: 0,
        perPage: 10,
        loading: false,
        requisitions: [],
        isLoading: {},
        error: null,
        filters: {
          status: "",
          start_date: "",
          end_date: ""
        },
      };
    },
    computed: {
      visiblePages() {
        return this.calculatePageRange();
      },
      filteredRequisitions() {
        const search = this.searchQuery.toLowerCase();
  
        return this.requisitions.filter((requisition) => {
          const statusValue = requisition.status || '';
          const startDetValue = requisition.date_added || '';
          const endDateValue = requisition.date_added || '';
  
          const startDate = startDetValue && !isNaN(new Date(startDetValue).getTime())
            ? new Date(startDetValue).toISOString()
            : null;
          const endDate = endDateValue && !isNaN(new Date(endDateValue).getTime())
            ? new Date(endDateValue).toISOString()
            : null;

          const matchesSearch =
          statusValue.toLowerCase().includes(search) ||
            (startDate && startDate.toLowerCase().includes(search)) ||
            (endDate && endDate.toLowerCase().includes(search))
  
          // Check dropdown filters (case-insensitive)
          const matchesStartDate = !this.filters.start_date || startDate.startsWith(this.filters.start_date);
          const matchesEndDate = !this.filters.end_date || endDate.startsWith(this.filters.end_date);
          const matchesStatus = !this.filters.status || statusValue.toLowerCase() === this.filters.status.toLowerCase();
  
          return matchesSearch && matchesStartDate && matchesStatus && matchesEndDate;
        });
      }
  
    },
  
    watch: {
      filters: { deep: true, handler: 'getRequisitions' },
      searchQuery: 'getRequisitions'
    },

    mounted() {
      this.user = this.$store.getters["auth/user"];
      this.facility_logo = this.user.user_roles[0]?.facility_department?.facility?.logo;
    },
  
    methods: {
      applyFilters(filters) {
        this.filters = { ...this.filters, ...filters };
        this.currentPage = 1;
      },
  
      resetFilters() {
        this.filters = {
          status: "",
          start_date: "",
          end_date: ""
        };
        this.currentPage = 1;
      },
  
      async getRequisitions() {
        this.loading = true;
        try {
          const queryParams = { ...this.filters, search_query: this.searchQuery, page: this.currentPage, per_page: this.perPage };
          const response = await api.fetchRequisitionsReports(queryParams);
          this.requisitions = response.data || response;
          this.currentPage = response.current_page;
          this.totalPages = response.total_pages;
        } catch (error) {
          this.error = error.message || "Failed to fetch requisitions";
        } finally {
          this.loading = false;
        }
      },
  
      calculatePageRange() {
        const maxPagesToShow = 5;
        let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);
  
        // Adjust start page if we're near the end
        if (endPage - startPage + 1 < maxPagesToShow) {
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }
  
        return Array.from(
          { length: endPage - startPage + 1 },
          (_, i) => startPage + i
        );
      },
  
      goToPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.getRequisitions();
        }
      },
      async previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          await this.getRequisitions();
        }
      },
      async nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          await this.getRequisitions();
        }
      },
  
      calculateDaysRemaining(expiryDate) {
        const today = new Date();
        const expiry = new Date(expiryDate);
        const timeDiff = expiry - today;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysRemaining;
      },

      async handleDownloadMadeRequisitions() {
          const printWindow = document.createElement('iframe');
          printWindow.style.position = 'absolute';
          printWindow.style.width = '0';
          printWindow.style.height = '0';
          document.body.appendChild(printWindow);


          try {
            // Generate table content from filteredBloodProducts
            const queryParams = {
              search_date: this.dateRange,
              search_query: this.searchQuery,
              all: true
            };

            const response = await api.fetchRequisitionsReports(queryParams);
            const requisition_data = response.data || response;

            const tableRows = requisition_data.map((data, index) => `
          <tr class="border-b text-sm">
            <td class="px-3 py-1">${index + 1}</td>
            <td class="px-3 py-1">${data.patient?.first_name} ${data.patient?.last_name}</td>
            <td class="px-3 py-1">${data.patient?.ipop || ''}</td>
            <td class="px-3 py-1">${new Date(data.date_added).toLocaleString()}</td>
            <td class="px-3 py-1">${data.nurse_in_charge?.first_name} ${data.nurse_in_charge?.last_name}</td>
            <td class="px-3 py-1">${data.department?.name}</td>
            <td class="px-3 py-1">${data.status}</td>
          </tr>
        `).join('');


            // Prepare print content
            const printContent = `
          <div class="page-container">
            <div class="report-container">
              <div class="logo-container">
                  <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
                </div>
              <br><br>
              <h1 class="text-lg font-bold mb-4">Requisitions Report</h1>
              <p class="mb-4">Generated on: ${new Date().toLocaleString()}</p>
              
              <div class="table-container">
                <table class="w-full text-left">
                  <thead>
                    <tr class="bg-gray-100">
                      <th class="px-6 py-2"></th>
                      <th class="px-6 py-2">Patient Name</th>
                      <th class="px-6">Patient IPOP</th>
                      <th class="px-6">Requisition Date</th>
                      <th class="px-6">Nurse Incharge</th>
                      <th class="px-6">Ward</th>
                      <th class="px-6">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tableRows}
                  </tbody>
                </table>
              </div>

              <div class="signatures mt-8">
                <div class="signature-line">
                  <p>Prepared by: _________________</p>
                  <p>Date: _________________</p>
                </div>
                <div class="signature-line mt-4">
                  <p>Verified by: _________________</p>
                  <p>Date: _________________</p>
                </div>
              </div>
            </div>
          </div>
        `;

            // Prepare the full document for printing
            const printDocument = `
          <html>
          <head>
            <title>Issued Units Report</title>
            <style>
              @media print {
                @page {
                  size: A4;
                  margin: 2cm;
                }
              }
              
              body {
                font-family: Arial, sans-serif;
                line-height: 1.6;
                color: #333;
                margin: 0;
                padding: 0;
              }
              .logo{
                width: 120px;
                float:right
              }

              .page-container {
                padding: 20px;
              }

              .report-container {
                max-width: 100%;
                margin: 0 auto;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 20px;
                font-size: 10.5px;
              }

              th, td {
                border: 1px solid #ddd;
                padding: 8px;
                text-align: left;
              }

              th {
                background-color: #F3F4F6;
                font-weight: bold;
              }

              .signatures {
                margin-top: 40px;
                page-break-inside: avoid;
                font-size: 10.5px;
              }

              .signature-line {
                margin-bottom: 20px;
              }

              @media print {
                .status-badge {
                  border: 1px solid #ddd;
                }
              }
            </style>
          </head>
          <body>
            ${printContent}
          </body>
          </html>
        `;

            // Open the print document
            printWindow.contentDocument.open();
            printWindow.contentDocument.write(printDocument);
            printWindow.contentDocument.close();

            // Print when the document is loaded
            printWindow.contentWindow.onload = function () {
              printWindow.contentWindow.print();
              // Remove the iframe after printing
              setTimeout(() => {
                document.body.removeChild(printWindow);
              }, 1000);
            };
          } catch (error) {
            console.error('Error generating report:', error);
          }
        },
      },
    };
  </script>
  
  <style lang="css" scoped></style>
  